import {WHITE} from '../../colors'
import {BU_SHAPE} from '../block-units'

export const PRIMARY_SHAPE = 'primary_shape'

export function getBlockShapeModel() {
    return {
        key: PRIMARY_SHAPE,
        unit: BU_SHAPE,
        tag: 'rect',
        label: 'Block shape',
        attrs: {
            fill: WHITE,
            filter: 'url(#shadow)'
        },
        allowEditShape: false,
        editableAttrs: {}
    }
}
